import BaseModelInstance from './base.model'
import { Resource as ModelDefinition } from './model-definitions'

class Resource extends BaseModelInstance {
  afterSet = (key, value) => {}

  constructor(attribs) {
    super(ModelDefinition, attribs)
  }
}

export default Resource
